import emptyFunction from "@jnctn/core/utilities/emptyFunction";
import { createContext, SetStateAction, Dispatch } from "react";

export type Tenant = string;

const TenantContext = createContext<{
  tenant: Tenant | undefined;
  setTenant: Dispatch<SetStateAction<Tenant | undefined>>;
}>({
  tenant: undefined,
  setTenant: emptyFunction,
});

export default TenantContext;
